(function () {
  function initWholesalePartner(root) {
    if (!root || root.dataset.trackingReady === 'true') return;
    root.dataset.trackingReady = 'true';

    root.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-wholesale-cta]');
      if (!cta || !root.contains(cta)) return;

      var detail = {
        cta_name: cta.dataset.wholesaleCta,
        destination: cta.href || '',
        page_handle: root.dataset.pageHandle || 'wholesale-partner',
        page_path: window.location.pathname
      };

      window.dispatchEvent(new CustomEvent('sanseking:wholesale_partner_cta', { detail: detail }));

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'wholesale_partner_cta_click',
        cta_name: detail.cta_name,
        destination: detail.destination,
        page_handle: detail.page_handle,
        page_path: detail.page_path
      });

      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish('wholesale_partner_cta_click', detail);
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-wholesale-partner]').forEach(initWholesalePartner);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initWholesalePartner(event.target.querySelector('[data-wholesale-partner]'));
  });
})();
